const ListenForResponseOnAlexaContent = () => {
  return null;
};

export default ListenForResponseOnAlexaContent;
